import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/brics-website/brics-website/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/brics-website/brics-website/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/brics-website/brics-website/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["AnalyticsTracker"] */ "/home/runner/work/brics-website/brics-website/sections/analytics-tracker/analytics-tracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["YaAnalyticsScript"] */ "/home/runner/work/brics-website/brics-website/sections/analytics-tracker/ya-analytics-script.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/home/runner/work/brics-website/brics-website/sections/footer/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/home/runner/work/brics-website/brics-website/sections/header/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BurgerMenu"] */ "/home/runner/work/brics-website/brics-website/sections/header/ui/burger-menu/burger-menu.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/brics-website/brics-website/sections/header/ui/modal-footer/modal-footer.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["TagLink"] */ "/home/runner/work/brics-website/brics-website/shared/ui/tag-link/tag-link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Text"] */ "/home/runner/work/brics-website/brics-website/shared/ui/text/text.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/brics-website/brics-website/shared/utils/common.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/brics-website/brics-website/shared/utils/hooks.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/brics-website/brics-website/styles/foundation/index.scss");
